import React, { FC } from 'react';

import useJoiValidation from '../../hooks/useJoiValidation';
import { contentBackgroundImageSchema } from './ContentBackgroundImage.schema';
import { IContentBackgroundImage } from './models';

import './ContentBackgroundImage.scss';

const ContentBackgroundImage: FC<IContentBackgroundImage> = ({ backgroundImage }) => {
  const {
    data,
  }: {
    data: IContentBackgroundImage;
  } = useJoiValidation(contentBackgroundImageSchema, 'ContentBackgroundImage', {
    backgroundImage,
  });

  return (
    <div
      className="content-background-image"
      style={{ backgroundImage: `url(${data.backgroundImage.url})` }}
    >
      {/* <ExtendableImage props={{ src: data.backgroundImage.url }} /> */}
    </div>
  );
};

export default ContentBackgroundImage;
